import React from "react";
import { useTranslation } from "react-i18next";

export const logos = [
  {
    src: "https://website-resource.ahaglobal.io/ads-website/0826home/brand-logo/manna.png",
    alt: "Manna",
    key: "manna",
  },
  {
    src: "https://website-resource.ahaglobal.io/ads-website/0826home/brand-logo/vivagoAi.png",
    alt: "Vivago",
    key: "vivago",
  },
  {
    src: "https://website-resource.ahaglobal.io/ads-website/0826home/brand-logo/onlyoffice.png",
    alt: "Onlyoffice",
    key: "onlyoffice",
  },
  {
    src: "https://website-resource.ahaglobal.io/ads-website/0826home/brand-logo/aippt.png",
    alt: "Aippt",
    key: "aippt",
  },
  {
    src: "https://website-resource.ahaglobal.io/ads-website/0826home/brand-logo/vizard.png",
    alt: "Vizard",
    key: "vizard",
  },
  {
    src: "https://website-resource.ahaglobal.io/ads-website/0826home/brand-logo/metagpt.png",
    alt: "Meta",
    key: "metagpt",
  },
  {
    src: "https://website-resource.ahaglobal.io/ads-website/0826home/brand-logo/qacdora.png",
    alt: "Qacdora",
    key: "pacdora",
  },
  {
    src: "https://website-resource.ahaglobal.io/ads-website/0826home/brand-logo/pageon.png",
    alt: "Pageon",
  },
  {
    src: "https://website-resource.ahaglobal.io/ads-website/0826home/brand-logo/roleza.png",
    alt: "Roleza",
  },
  {
    src: "https://website-resource.ahaglobal.io/ads-website/0826home/brand-logo/shakker.png",
    alt: "Shakker",
    key: "shakker",
  },
  {
    src: "https://website-resource.ahaglobal.io/ads-website/0826home/brand-logo/clawlab.png",
    alt: "clawlab",
    key: "clawlab",
  },
  {
    src: "https://website-resource.ahaglobal.io/ads-website/0826home/brand-logo/zeabur.png",
    alt: "zeabur",
    key: "zeabur",
  },
  {
    src: "https://website-resource.ahaglobal.io/ads-website/0826home/brand-logo/laipic.png",
    alt: "laipic",
  },
  {
    src: "https://website-resource.ahaglobal.io/ads-website/0826home/brand-logo/fantasia.png",
    alt: "fantasia",
    key: "fantasiabedtimestories",
  },
  {
    src: "https://website-resource.ahaglobal.io/ads-website/0826home/brand-logo/autocoder.png",
    alt: "AutoCoder",
    key: "autocoder",
  },
  {
    src: "https://website-resource.ahaglobal.io/ads-website/0826home/brand-logo/pixso.png",
    alt: "Pixso",
    key: "pixso",
  },
  {
    src: "https://website-resource.ahaglobal.io/ads-website/0826home/brand-logo/presenti.png",
    alt: "Presenti",
  },
  {
    src: "https://website-resource.ahaglobal.io/ads-website/0826home/brand-logo/boardmix.png",
    alt: "Boardmix",
  },
  {
    src: "https://website-resource.ahaglobal.io/ads-website/0826home/brand-logo/zoer.png",
    alt: "Zoer",
    key: "zoer",
  },
  {
    src: "https://website-resource.ahaglobal.io/ads-website/0826home/brand-logo/buildin.png",
    alt: "Buildin",
    key: "buildin",
  },
  {
    src: "https://website-resource.ahaglobal.io/ads-website/0826home/brand-logo/vmeg.png",
    alt: "VMEG",
    key: "VMEG",
  },
  {
    src: "https://website-resource.ahaglobal.io/ads-website/0826home/brand-logo/codeflying.png",
    alt: "CodeFlying",
    key: "codeflying",
  },
];

export default function LogoScroll() {
  const { t } = useTranslation();
  return (
    <div className="logo-carousel-container mt-10">
      <div className="flex justify-start items-center gap-[56px] mb-4">
        <div className="flex-1 h-[1px] bg-divide" />
        <div className="justify-start text-font&icon-helper text-sm font-medium font-['DM_Sans'] leading-snug">
          {t("components.checkDepositModal.extraRights")}
        </div>
        <div className="flex-1 h-[1px] bg-divide" />
      </div>
      <div className="logo-carousel-track">
        {/* 第一组logo */}
        {logos.map((logo, index) => (
          <div
            className={`logo-item flex-shrink-0 relative min-h-[50px] flex items-center ${
              logo.key ? "cursor-pointer" : ""
            }`}
            key={`first-${index}`}
            onClick={() => {
              if (logo.key) {
                window.open(
                  `https://www.ahacreator.com/case-studies/${logo.key}`,
                  "_blank",
                );
              }
            }}
          >
            <img src={logo.src} alt={logo.alt} className="w-full" />
            {logo?.key && (
              <div className="bg-[#FFEAD5] absolute top-[-6px] left-[10px] flex items-center px-[4px] text-[#FB6011] text-[10px] font-medium font-['DM_Sans'] leading-normal rounded-full">
                {t("components.checkDepositModal.caseStudy")}
              </div>
            )}
          </div>
        ))}

        {/* 第二组logo（用于无缝循环） */}
        {logos.map((logo, index) => (
          <div
            className={`logo-item flex-shrink-0 relative min-h-[50px] flex items-center ${
              logo.key ? "cursor-pointer" : ""
            }`}
            key={`second-${index}`}
            onClick={() => {
              if (logo.key) {
                window.open(
                  `https://www.ahacreator.com/case-studies/${logo.key}`,
                  "_blank",
                );
              }
            }}
          >
            <img src={logo.src} alt={logo.alt} className="w-full" />
            {logo?.key && (
              <div className="bg-[#FFEAD5] absolute top-[-6px] left-[10px] flex items-center px-[4px] text-[#FB6011] text-[10px] font-medium font-['DM_Sans'] leading-normal rounded-full">
                {t("components.checkDepositModal.caseStudy")}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
